import { Link } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'
import { H2, Paragraph, SmallParagraph, SmallText } from '../../components/typography/Typography'
import { ANALYTICS_EVENTS, track } from '../../lib/analytics'
import { EQUIPMENT, EQUIPMENT_PATH } from '../Equipment/equipmentCatalog'

const BROCHURE_HREF = '/resource-centre'

export const FacilityEquipment = () => {
    return (
        <section id='equipment' className='flex flex-col gap-6 bg-gray-100 px-4 py-12 md:gap-9 md:px-24 md:py-16'>
            <div className='flex flex-col gap-3 border-b border-gray-300 pb-6 md:gap-4 md:pb-9 lg:flex-row lg:items-end lg:justify-between lg:gap-16'>
                <div className='flex flex-col gap-3 md:gap-4 lg:max-w-2xl'>
                    <SmallText className='tracking-[0.25em] text-my-orange'>Division 03 — Equipment</SmallText>
                    <H2>Sports facility equipment</H2>
                    <Paragraph className='text-gray-600'>
                        Backstops, backboards, timing, padding, curtains and floor protection —
                        specified with the floor, not after it.
                    </Paragraph>
                </div>
                <Link
                    to={BROCHURE_HREF}
                    onClick={() =>
                        track(ANALYTICS_EVENTS.HOME_EQUIPMENT_CATALOGUE_CLICKED, { destination: BROCHURE_HREF })
                    }
                    className='hidden shrink-0 rounded-full border border-gray-300 bg-white px-7 py-4 text-center font-inter text-gray-900 transition-colors hover:border-gray-900 lg:block'
                >
                    Request the catalogue&nbsp;&rarr;
                </Link>
            </div>

            <div className='grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-5'>
                {EQUIPMENT.map(({ slug, name, note, image, isCutout }) => (
                    <Link
                        key={slug}
                        to={`${EQUIPMENT_PATH}/${slug}`}
                        onClick={() =>
                            track(ANALYTICS_EVENTS.HOME_EQUIPMENT_CARD_CLICKED, {
                                equipment: name,
                                destination: `${EQUIPMENT_PATH}/${slug}`,
                            })
                        }
                        className='group flex flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white transition-colors hover:border-gray-400'
                    >
                        <img
                            src={image}
                            alt={name}
                            loading='lazy'
                            decoding='async'
                            className={twMerge(
                                'h-28 w-full md:h-32',
                                isCutout ? 'bg-white object-contain p-2' : 'object-cover'
                            )}
                        />
                        <div className='flex flex-1 flex-col gap-1.5 p-4'>
                            <SmallParagraph className='font-medium text-gray-900'>{name}</SmallParagraph>
                            <SmallParagraph className='text-gray-600'>{note}</SmallParagraph>
                        </div>
                    </Link>
                ))}
            </div>

            <Link
                to={BROCHURE_HREF}
                onClick={() =>
                    track(ANALYTICS_EVENTS.HOME_EQUIPMENT_CATALOGUE_CLICKED, { destination: BROCHURE_HREF })
                }
                className='rounded-full border border-gray-300 bg-white px-6 py-4 text-center font-inter text-gray-900 transition-colors hover:border-gray-900 lg:hidden'
            >
                Download Brochures&nbsp;&rarr;
            </Link>
        </section>
    )
}
